import { AssignAgencyForm } from 'components/forms/assign-agency-form/assign-agency-form';
import { useCallback } from 'react';
import { closeModal } from 'store/modals/modals.slice';

import { ASSIGN_AGENCY_MODAL } from '../../../shared/constants/modals';
import { useAppDispatch, useAppSelector } from '../../../store';
import { Modal } from '../../template/modals/modal';

export const AssignAgencyModal = () => {
  const dispatch = useAppDispatch();

  const modal = useAppSelector((state) =>
    state.modals.find((modal) => modal.name === ASSIGN_AGENCY_MODAL),
  );

  const handleClose = useCallback(() => {
    dispatch(closeModal({ name: ASSIGN_AGENCY_MODAL }));
  }, [dispatch]);

  if (!modal || !modal.isOpen) {
    return null;
  }

  return (
    <Modal close={handleClose}>
      <AssignAgencyForm assignAgencies={modal.data.agencies || []} />
    </Modal>
  );
};
